import { useIdleTimer as libUseIdleTimer } from "react-idle-timer";

type UseIdleProps = {
  onIdle: () => void; // function to run when idle timeout is triggered
  idleTimeSeconds: number; // number of seconds to wait before the onIdle function is called
};

export const useIdleTimer = ({ onIdle, idleTimeSeconds = 1 }: UseIdleProps) => {
  const idleTimeout = 1000 * idleTimeSeconds;
  libUseIdleTimer({
    timeout: idleTimeout,
    onIdle,
    debounce: 500,
  });
};
